import { render, staticRenderFns } from "./CustomerPriceListForm.vue?vue&type=template&id=3a821063&scoped=true&"
import script from "./CustomerPriceListForm.vue?vue&type=script&lang=js&"
export * from "./CustomerPriceListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a821063",
  null
  
)

export default component.exports